import { useCallback, useState } from "react";
import { resolveApiUrl } from "../../../apiBase";

const apiBaseUrl = resolveApiUrl();

/* ================================================================
   useWidgetSamtal — hörnwidgetens samtal sparas i KanAI-historiken
   (Mikael F21 "a", 2026-10-26, UX-granskning U34).

   Samma API som KanAI-sidan (/api/kanai/conversations): första svaret
   skapar konversationen, följande svar uppdaterar den. Felmeddelanden
   sparas inte. "Ny konversation" i widgeten startar ett nytt samtal;
   det gamla ligger kvar i historiken.
   ================================================================ */
export default function useWidgetSamtal() {
  const [samtalId, setSamtalId] = useState(null);
  const [sparfel, setSparfel] = useState(false);

  const spara = useCallback(async (meddelanden) => {
    const lagrade = (meddelanden || [])
      .filter((m) => (m.role === "user" || m.role === "assistant") && !m.error)
      .map((m) => ({ role: m.role, content: m.content }));
    if (!lagrade.some((m) => m.role === "assistant")) return;
    try {
      if (samtalId) {
        const res = await fetch(apiBaseUrl + `/api/kanai/conversations/${encodeURIComponent(samtalId)}`, {
          method: "PATCH", headers: { "Content-Type": "application/json" }, credentials: "include",
          body: JSON.stringify({ messages: lagrade }),
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
      } else {
        const forsta = lagrade.find((m) => m.role === "user")?.content || "";
        const res = await fetch(apiBaseUrl + "/api/kanai/conversations", {
          method: "POST", headers: { "Content-Type": "application/json" }, credentials: "include",
          body: JSON.stringify({
            title: forsta.slice(0, 120) || "Samtal i hörn-KanAI",
            modeId: "kanai_project_coach",
            messages: lagrade,
          }),
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const skapad = await res.json();
        setSamtalId(skapad.id);
      }
      setSparfel(false);
    } catch (_e) {
      setSparfel(true);
    }
  }, [samtalId]);

  const nyttSamtal = useCallback(() => {
    setSamtalId(null);
    setSparfel(false);
  }, []);

  return { samtalId, sparfel, spara, nyttSamtal };
}
